import React from 'react';
import "./SocialProof.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SocialProof = () => {
  const testimonials = [
    {
      name: "María González",
      post: "Propietaria",
      paragraph: "Desde que confié mi piso a Tu Inquilino Ideal, recibo mi renta puntual cada mes sin preocuparme de nada. La casa está impecable y los inquilinos son excelentes."
    },
    {
      name: "Carlos Rodríguez",
      post: "Propietario",
      paragraph: "Después de malas experiencias con inquilinos, encontré la solución perfecta. Cero riesgos y tranquilidad total. ¡Recomiendo encarecidamente!"
    },
    {
      name: "Ana López",
      post: "Propietaria",
      paragraph: "El equipo profesional se encarga de todo. Mi propiedad ha mejorado mucho y genero ingresos pasivos sin esfuerzo. Una inversión segura."
    },
    {
      name: "Javier Martínez",
      post: "Propietario de Inmuebles",
      paragraph: "Tu Inquilino Ideal ha transformado mi portafolio inmobiliario. Sus estrategias de inversión son impecables y los resultados hablan por sí solos."
    },
    {
      name: "Laura Sánchez",
      post: "Agente Inmobiliaria",
      paragraph: "Como profesional del sector, recomiendo Tu Inquilino Ideal sin dudarlo. Su expertise en Buy2Rent y gestión de alquileres es excepcional."
    },
    {
      name: "Roberto Díaz",
      post: "Empresario",
      paragraph: "Invertir con Tu Inquilino Ideal me ha dado tranquilidad financiera. Su equipo es profesional y los rendimientos son consistentes."
    }
  ];

  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className='socialproof section-p' id="socialproof">
        <div className='container'>
            <div className='socialproof-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>Lo que dicen nuestros <span className='text-dark'>Clientes</span></h3>
                    <p className='text'>Testimonios reales de clientes satisfechos con nuestros servicios inmobiliarios.</p>
                </div>

                <div className='socialproof-list'>
                    <Slider {...settings}>
                        {
                            testimonials.map((testimonial, index) => {
                                return (
                                    <div className='socialproof-item text-center' key={index}>
                                        <p className='text socialproof-text'>"{testimonial.paragraph}"</p>
                                        <div className='socialproof-author'>
                                            <h4 className='fs-18 fw-5'>{testimonial.name}</h4>
                                            <p className='text'>{testimonial.post}</p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        </div>
    </div>
  )
}

export default SocialProof